module.exports = __webpack_public_path__ + "img/STHander_Sword Two-Hander Base.43f9baf7.png";